export const breakpoints = {
    mediumMin: `min-width: 940px`,
};
